import React, { useContext, useEffect, useState } from 'react';
import { PageContext } from '../frontend/pageContext';
import { ClientMenuLink } from '../types';
interface Props {
  menu: any;
}

interface DocNavLink {
  url: string;
  title: string;
}

interface SearchState {
  found: boolean;
  prevLink?: DocNavLink;
  nextLink?: DocNavLink;
}

const PageNavButtons = ({ menu }: Props) => {
  const { docSpace, docLeaf, pathname } = useContext(PageContext);
  const [prevLink, setPrevLink] = useState<string | undefined>(undefined);
  const [nextLink, setNextLink] = useState<string | undefined>(undefined);
  const getItemInfo = (item: any): DocNavLink | undefined => {
    if (item?.type === 'externalMenuLink') {
      return {
        url: (item as ClientMenuLink).url,
        title: (item as ClientMenuLink).text,
      };
    }

    if (item?.type === 'menuLink') {
      return {
        url: item.path,
        title: item.text,
      };
    }

    return undefined;
  };

  const flattenMenu = (
    items: any[],
    acc: DocNavLink[] = [],
    status: SearchState,
  ) => {
    for (const item of items) {
      const currentItem = getItemInfo(item);
      const searchPath = pathname.split('#')[0];

      if (
        (item.type === 'menuLink' || item.type === 'externalMenuLink') &&
        currentItem
      ) {
        status.prevLink = acc[acc.length - 1];
        acc.push(currentItem);
      }

      if (item.type === 'menuLink' && item.path === searchPath) {
        status.found = true;
        setPrevLink(status.prevLink?.url);
      }

      if (
        status.found &&
        (item.type === 'menuLink' || item.type === 'externalMenuLink') &&
        status.prevLink?.url === searchPath &&
        currentItem
      ) {
        status.nextLink = currentItem;
        setNextLink(currentItem.url);
        return;
      }

      if (
        item.children &&
        item.children.length > 0 &&
        ((status.found && !status.nextLink) || !status.found)
      ) {
        flattenMenu(item.children, acc, status);
      }
    }
  };

  useEffect(() => {
    flattenMenu(menu.children, [], { found: false });
  }, [pathname, docSpace, docLeaf]);

  const isExternalLink = (url: string) => {
    return url.startsWith('http://') || url.startsWith('https://');
  };

  return (
    <>
      {prevLink && (
        <a
          href={prevLink}
          className="prev-btn"
          {...(isExternalLink(prevLink) && {
            target: '_blank',
            rel: 'noopener noreferrer',
          })}
        >
          {!isExternalLink(prevLink) && (
            <svg>
              <use
                href="/assets/images/left-arrow.svg#left-arrow"
                fill="currentColor"
              ></use>
            </svg>
          )}
          <div className="nav-btn-text">
            <span>Prev</span>
            {isExternalLink(prevLink) && (
              <svg className="external-link-icon">
                <use
                  href="/assets/images/offsite.svg#offsite"
                  fill="currentColor"
                ></use>
              </svg>
            )}
          </div>
        </a>
      )}
      {nextLink && (
        <a
          href={nextLink}
          className="next-btn"
          {...(isExternalLink(nextLink) && {
            target: '_blank',
            rel: 'noopener noreferrer',
          })}
        >
          <div className="nav-btn-text">
            <span>Next</span>
            {isExternalLink(nextLink) && (
              <svg className="external-link-icon">
                <use
                  href="/assets/images/offsite.svg#offsite"
                  fill="currentColor"
                ></use>
              </svg>
            )}
          </div>
          {!isExternalLink(nextLink) && (
            <svg>
              <use
                href="/assets/images/right-arrow.svg#right-arrow"
                fill="currentColor"
              ></use>
            </svg>
          )}
        </a>
      )}
    </>
  );
};

export default PageNavButtons;
